import { PnlBreakdown } from "../../../../getters/pnlBreakdownGetter/pnlBreakdownTypes";

/**
 * Custom uptime calculation for PCI
 *
 * @param {PnlBreakdown} {
 *   producing,
 *   unplanned,
 *   waiting,
 *   unknown
 * }
 * @return {*}  {(number | null)}
 */
export const getUptimePercent = ({
  producing,
  unplanned,
  waiting,
  unknown,
}: PnlBreakdown): number | null => {
  const denom =
    producing.durationMs +
    unplanned.durationMs +
    waiting.durationMs +
    unknown.durationMs;

  return denom === 0 || isNaN(denom)
    ? null
    : ((producing.durationMs -
        (producing.slowdownGainLossTime + unknown.minorStops.durationMs)) /
        denom) *
        100;
};
